export default "__VITE_ASSET__BfSr0Rkx__"